module.exports = __webpack_public_path__ + "80d4d29c.png";